module.exports = __webpack_public_path__ + "static/media/creativ7.c47f8213.jpg";